import React from "react";
import s from "./index.module.scss";
import Swatches from "components/forms/Swatches";
import PrivacyRating from "containers/ProductDetails/components/PrivacyRating";
import { Heading } from "@masonite/external-ui-react";
import { language } from "utility/env";

export default function GlassOptions(props) {
    const {
        borderRadius,
        containerState,
        options,
        selectedGlassType,
        selectedGlassDesign,
        setContainerState,
        swatchSize
    } = props;

    const defaultIconBg = "#ccc";

    const glassTypes =
        options.length &&
        options.map(type => ({
            label: type.value,
            value: type.hash,
            color: defaultIconBg,
            image: type.designs[0].image_url
        }));

    const glassDesigns = () =>
        selectedGlassType &&
        options
            .find(t => t.hash === selectedGlassType)
            .designs.map(type => ({
                ...type,
                label: type.title,
                value: type.hash,
                image: type.image_url,
                color: defaultIconBg
            }));

    const glassCamings = () => {
        if (!selectedGlassDesign) return false;
        const camings = options
            .find(t => t.hash === selectedGlassType)
            .designs.find(d => d.hash === selectedGlassDesign).camings;
        return (
            camings &&
            camings.map(type => ({
                label: type.value,
                value: type.hash,
                image: type.image,
                color: defaultIconBg
            }))
        );
    };

    const glassDesignPrivacy = () => {
        const designs = glassDesigns();
        const design = designs.find(d => d.value === selectedGlassDesign);
        return design && design.privacy;
    };

    return (
        <div className={s.options}>
            <Heading level="2">
                {language === "fr" ? "Options de verre" : "Glass Options"}
            </Heading>
            {glassTypes.length > 1 && (
                <>
                    <Heading level="3">
                        {language === "fr" ? "Les types" : "Types"}
                    </Heading>
                    <div className={s["swatch-wrapper"]}>
                        <Swatches
                            values={glassTypes}
                            borderRadius={borderRadius}
                            selectedSwatch={selectedGlassType}
                            swatchSize={swatchSize}
                            selectHandler={hash => {
                                setContainerState("selectedGlassDesign")(
                                    options.find(opt => opt.hash === hash)
                                        .designs[0].hash
                                );
                                setContainerState("selectedGlassType")(hash);
                            }}
                            scrollLeft={
                                props.containerState.selectGlassTypeScrollPos
                            }
                            handleUnmount={scrollLeft => {
                                if (
                                    containerState.selectGlassTypeScrollPos !==
                                    scrollLeft
                                )
                                    setContainerState(
                                        "selectGlassTypeScrollPos"
                                    )(scrollLeft);
                            }}
                            showLabels
                            showTooltip
                            handleTooltipClick={hash =>
                                containerState.showTooltipFor === hash
                                    ? setContainerState("showTooltipFor")(null)
                                    : setContainerState("showTooltipFor")(hash)
                            }
                            showTooltipFor={containerState.showTooltipFor}
                        />
                    </div>
                </>
            )}
            {selectedGlassType && (
                <div className={s.option}>
                    <Heading level="3">
                        {language === "fr" ? "Dessins" : "Designs"}
                    </Heading>
                    <div className={s["swatch-wrapper"]}>
                        <Swatches
                            values={glassDesigns()}
                            borderRadius={borderRadius}
                            selectedSwatch={selectedGlassDesign}
                            swatchSize={swatchSize}
                            selectHandler={hash => {
                                setContainerState("selectedGlassDesign")(hash);
                            }}
                            scrollLeft={
                                props.containerState.selectGlassDesignScrollPos
                            }
                            handleUnmount={scrollLeft => {
                                if (
                                    containerState.selectGlassDesignScrollPos !==
                                    scrollLeft
                                )
                                    setContainerState(
                                        "selectGlassDesignScrollPos"
                                    )(scrollLeft);
                            }}
                            showLabels
                            showTooltip
                            handleTooltipClick={hash =>
                                containerState.showTooltipFor === hash
                                    ? setContainerState("showTooltipFor")(null)
                                    : setContainerState("showTooltipFor")(hash)
                            }
                            showTooltipFor={containerState.showTooltipFor}
                        />
                    </div>
                </div>
            )}
            {selectedGlassDesign && (
                <div className={s.option}>
                    <Heading level="3">
                        {language === "fr" ? "Intimité" : "Privacy"}
                    </Heading>
                    <PrivacyRating rating={glassDesignPrivacy()} />
                </div>
            )}
            {selectedGlassDesign && glassCamings() && (
                <>
                    <h3>Camings</h3>
                    <Swatches
                        values={glassCamings()}
                        swatchSize={swatchSize}
                        borderRadius={borderRadius}
                    />
                </>
            )}
        </div>
    );
}
